import {Component, OnInit, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {CurrencyPipe, NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {
	MatTableDataSource,
	MatTableModule
} from "@angular/material/table";
import {Payment} from "../../models/payment/paymentOrder.model";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {PaymentService} from "../../services/payment/payment.service";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {SafeUrlPipe} from "../../pipe/save-pdf-url.pipe";

interface PageOptions {
	totalCount: number,
	page: number,
	pageSize: number,
	totalPages: number
}

@Component({
	selector: 'app-order-history',
	imports: [
		FormsModule,
		NgIf,
		CurrencyPipe,
		MatTableModule,
		MatPaginatorModule,
		NgSwitch,
		NgSwitchCase,
		SafeUrlPipe
	],
	templateUrl: './order-history.component.html',
	styleUrl: './order-history.component.sass'
})
export class OrderHistoryComponent implements OnInit {
	payments!: Payment[];
	displayedColumns = ['invoicenumber', 'status', 'price', 'vat', 'total', 'invoice'];
	dataSource = new MatTableDataSource<Payment>(this.payments);
	currentPageOptions!: PageOptions;
    isSmallScreen: boolean = false;

	@ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(
        private paymentService: PaymentService,
        private breakpointObserver: BreakpointObserver
    ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
          .subscribe(result => {
            this.isSmallScreen = result.matches;
          });
    }

    ngOnInit() {
      this.getPaymentsByUser();
    }

	paginatorChange(event: PageEvent): void {
		console.log(event);
		this.getPaymentsByUser(event);
	}

    getPaymentsByUser(pageOptions: PageEvent|undefined = undefined): void {
        this.paymentService.getPaymentsByUser(pageOptions).subscribe((response: any) => {
            this.payments = response.items.filter((payment: Payment) => payment.status !== 'unpaid');
            this.dataSource.data = this.payments;
			this.currentPageOptions = response;
            this.dataSource.paginator = this.paginator;
        });
    }
}
